import { Injectable } from '@angular/core';
import { InMemoryDbService, RequestInfo } from 'angular-in-memory-web-api';
import { PatientData } from '@ispm-shared/modules/patient';
import { PATIENT_DATA_URL } from '@ispm-client/modules/patient/services/config';
import { InMemoryBackendMockService } from '@ispm-client/modules/backend-mock-modules/backend-mock-service';
import { ServiceConfiguration } from '@ispm-client/modules/backend-mock-modules/backend-mock-service/services/config';
import { HTTP_METHODS } from '@ispm-client/modules/backend-mock-modules/backend-mock-service/services/in-memory-data.service';

const patients: PatientData[] = [
  {
    mrn: '1',
    Treatment_preferences: 'Chemotherapy',
    Cell_type: 'Squamous',
    PS: '0',
    cancerType: 'Breast',
    histology: '',
    smoking: '',
    therapy_eligable_a: '',
    mutation_type: '',
    target_mutation_a: '',
    target_mutation_b: '',
    pdl1_expression: '',
    a: '',
    b: '',
    pdl1_expression_b: '',
    therapy_eligable_b: '',
    egfr_type: ''
  },
  {
    mrn: '2',
    Treatment_preferences: 'Chemotherapy',
    Cell_type: 'Squamous',
    PS: '0',
    cancerType: 'Breast',
    histology: '',
    smoking: '',
    therapy_eligable_a: '',
    mutation_type: '',
    target_mutation_a: '',
    target_mutation_b: '',
    pdl1_expression: '',
    a: '',
    b: '',
    pdl1_expression_b: '',
    therapy_eligable_b: '',
    egfr_type: ''
  }
];

@Injectable()
export class PatientBackendMockService {

  constructor(private imdb: InMemoryDbService) {
    (imdb as InMemoryBackendMockService).registerHandler(ServiceConfiguration.getBaseURL(PATIENT_DATA_URL), HTTP_METHODS.GET, this.getPatients);
  }

  private getPatients(reqInfo: RequestInfo) {
    let data: PatientData;
    reqInfo.query.entries();
    const mrn = reqInfo.query.get('mrn');

    if (mrn) {
      data = patients.find((b) => b.mrn === mrn[0]);
    } else {
      // todo
    }
    return data;
  }


}
